import { Flex } from '@mantine/core';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme.ts';
import { Row } from '@tanstack/react-table';
import { InvestorVestingExpandedContent } from './InvestorVestingExpandedContent.tsx';
import { InvestorLoanDetailPanel } from './InvestorLoanDetailPanel.tsx';
import type { HoldingsTableRow } from '@dealstack/frontend/investor/pages/Valuations/InvestorHoldingsTable/utils/types.ts';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

const SECTION_BORDER = `1px solid ${defaultTheme.v3.colors.gray[4]}`;

interface Props {
	row: Row<HoldingsTableRow>;
	rows: HoldingsTableRow[];
}

export const InvestorHoldingsDetailPanel = ({ row, rows }: Props) => {
	const tInvestor = useTranslationInvestor();
	const original = row.original;
	const nextRow = rows[row.index + 1];
	const hasLoanAfter = !!nextRow?._loans;
	const isLastGroup = !rows.slice(row.index + 1).some((r) => !r._loans);

	if (original._loans?.length) {
		return (
			<Flex
				style={{ flex: 1, ...(isLastGroup ? undefined : { borderBottom: SECTION_BORDER }) }}
			>
				<InvestorLoanDetailPanel loans={original._loans} tInvestor={tInvestor} />
			</Flex>
		);
	}

	if (original.isSubjectToVesting) {
		return (
			<Flex
				direction="column"
				p="0.5rem"
				style={{
					flex: 1,
					...(hasLoanAfter ? undefined : { borderBottom: SECTION_BORDER }),
				}}
			>
				<InvestorVestingExpandedContent
					investorId={original._investorId}
					securityId={original.securityId}
					tInvestor={tInvestor}
				/>
			</Flex>
		);
	}

	return null;
};
